import { Spinner } from '@ds';

export const LoadingFallback = () => (
  <div className="w-full h-dvh flex overflow-hidden items-center justify-center">
    <Spinner size="lg" />
  </div>
);
